<template>
  <div class="chart-transition-wrapper" :class="{ 'is-loading': isLoading }">
    <modern-bar-chart
      :title="title"
      :series="series"
      :categories="categories"
      :colors="chartColors"
      :height="300"
      :stacked="false"
      :horizontal="false"
      type="line"
      :display-mode="displayMode"
      percent-basis="series"
    />
  </div>
</template>

<script>
import { getComplaintsPerMonth } from "../../../../api/charts";
import ModernBarChart from "../ModernBarChart.vue";
import { displayModeMixin } from "../displayModeMixin";

export default {
  name: "ComplaintsPerMonth",
  mixins: [displayModeMixin],
  components: {
    ModernBarChart,
  },
  props: {
    company: {
      type: [Number, String],
      default: null,
    },
    year: {
      type: Number,
      default: () => new Date().getFullYear(),
    },
  },

  data() {
    return {
      title: "",
      series: [],
      categories: [],
      chartColors: ["#007bff", "#28a745"],
      isLoading: false,
    };
  },

  watch: {
    company: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
    year: {
      immediate: false,
      handler() {
        this.loadData();
      },
    },
  },

  methods: {
    async loadData() {
      try {
        // Iniciar transição suave
        this.isLoading = true;

        const response = await getComplaintsPerMonth(this.company, this.year);
        const data = response.data;

        // Gerar 12 meses do ano selecionado
        const yearMonths = this.getYearMonths();

        // Mapear dados recebidos
        const receivedMap = {};
        if (data.received) {
          for (const item of data.received) {
            const monthKey = `${item._id.year}-${item._id.month
              .toString()
              .padStart(2, "0")}`;
            receivedMap[monthKey] = item.count;
          }
        }

        // Mapear dados concluídos
        const concludedMap = {};
        if (data.concluded) {
          for (const item of data.concluded) {
            const monthKey = `${item._id.year}-${item._id.month
              .toString()
              .padStart(2, "0")}`;
            concludedMap[monthKey] = item.count;
          }
        }

        // Preparar arrays de dados para os 12 meses do ano
        const receivedData = [];
        const concludedData = [];
        const labels = [];

        for (const monthInfo of yearMonths) {
          labels.push(monthInfo.label);
          receivedData.push(receivedMap[monthInfo.key] || 0);
          concludedData.push(concludedMap[monthInfo.key] || 0);
        }

        this.categories = labels;
        this.series = [
          {
            name: "Denúncias Recebidas",
            data: receivedData,
          },
          {
            name: "Denúncias Concluídas",
            data: concludedData,
          },
        ];

        // Aguardar um momento e finalizar transição
        setTimeout(() => {
          this.isLoading = false;
        }, 100);
      } catch (error) {
        this.isLoading = false;
        console.error("Erro ao carregar dados do gráfico:", error);
        this.$bvToast.toast("Erro ao carregar dados de denúncias por mês", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      }
    },
    getYearMonths() {
      const months = [];

      for (let month = 1; month <= 12; month++) {
        const monthKey = `${this.year}-${month.toString().padStart(2, "0")}`;
        const label = this.getMonthLabel(month);

        months.push({ key: monthKey, label });
      }

      return months;
    },
    getMonthLabel(month) {
      const months = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ];
      return months[month - 1];
    },
  },
};
</script>
<style scoped>
.chart-transition-wrapper {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

.chart-transition-wrapper.is-loading {
  opacity: 0.6;
}
</style>
